import React, { useState, useReducer, useContext } from 'react';

import { PASSWORD_ERROR } from './constant';
import { AuthContext } from '../../context/auth/authContext';

// Components
import CreateChannelForm from './CreateChannelForm';
import CreateProfileForm from './CreateProfileForm';
import Spinner from '../Spinner/Spinner';

const initialInputState = {
	channelName: '',
	subtitle: '',
	accountEmail: '',
	link: '',
	description: '',
	fullName: '',
	userName: '',
	dateOfBirth: '',
	userEmail: '',
	password: '',
	confirmPassword: ''
};

export const JoinForm = () => {
	const { handleSignUp, isUserLoading } = useContext(AuthContext);
	const [passwordError, setPasswordError] = useState('');

	const [inputValues, setInputValues] = useReducer(
		(state, newState) => ({ ...state, ...newState }), initialInputState);

	const handleOnChange = event => {
		const { name, value } = event.target;

		setInputValues({ [name]: value });
	};

	const validate = () => {
		if (password.value !== confirmPassword.value) {
			setPasswordError(PASSWORD_ERROR);

			return false;
		}

		return true;
	};

	const handleSubmit = event => {
		event.preventDefault();

		const isValid = validate();

		if (isValid) {
			setPasswordError('');
			handleSignUp(inputValues);
		}

	};

	return (
		<div className="form_w">
			<form className="page_form" onSubmit={handleSubmit}>
				<div className="section_heading center_level_mod offset_mod">
					<h2 className="section_title accent_mod hero_mod">Create your streaming channel</h2>
					<div className="section_descr accent_mod">
						<p>Creati If you have any questions or having trouble using the app, please look at the articles below of contact us</p>
					</div>
				</div>
				<CreateChannelForm handleOnChange={handleOnChange} />
				<div className="section_heading center_level_mod offset_mod">
					<h2 className="section_title accent_mod hero_mod">Create your profile</h2>
					<div className="section_descr accent_mod">
						<p>Creati If you have any questions or having trouble using the app, please look at the articles below of contact us</p>
					</div>
				</div>
				<CreateProfileForm
					handleOnChange={handleOnChange}
					passwordError={passwordError}
				/>
				<div className="form_btn_w center_level_mod">
					<button
						className="btn_v2 full_mod"
						type="submit"
						value="Submit"
						disabled={isUserLoading}
					>
						{isUserLoading ? (
							<Spinner />
						) : 'Submit'}
					</button>
				</div>
			</form>
		</div>
	);
}
export default JoinForm;